import { DTO } from '../DTO'
import type { AdditionalPricingPlanType, PlanNameValue } from './Payment'

/**
 * **2024.02.07 프리미엄 요금제 배포에 따른 요금제 관련 필드**
 *
 * **PaymentStudent.count가 요금제에 따라 의미가 바뀌기 때문에, 어떤 의미에서 호출하는지 판단할 수 있는 값으로 사용
 * - NUMBER_OF_SOLVED_PROBLEM 채점 문제 수 기준 (BASIC)
 * - NUMBER_OF_ACTIVE_DAYS 재원일수 기준 (NEW_BASIC, PREMIUM)
 */
export class AcademyPayment extends DTO {
  private _subscribePlan: PlanNameValue | null = null
  private _subscribeFee = 0
  private _additionalPricingPlan: AdditionalPricingPlanType | null = null
  private _additionalFee = 0
  private _additionalHwpFee = 0
  private _hwpProblemCount = 0
  private _additionalPricingPlanStandardValue: number | null = null
  private _additionalPricingPlanFreeStudentCount: number | null = null
  private _additionalPricingPlanFeeOnEachStudent: number | null = null
  private _additionalStudentCount: number | null = null
  private _activeStudentCount: number | null = null
  private _invoiceStartDatetime: Date
  private _invoiceEndDatetime: Date
  private _paymentDate: Date
  private _paymentAmount = 0 // 기본요금 + 추가요금 (문자 요금, 미수금은 제외)
  private _debt = 0 // 미수금

  get subscribePlan() {
    return this._subscribePlan
  }

  get subscribeFee() {
    return this._subscribeFee
  }

  get additionalPricingPlan() {
    return this._additionalPricingPlan
  }

  get additionalFee() {
    return this._additionalFee
  }

  get additionalHwpFee() {
    return this._additionalHwpFee
  }

  get hwpProblemCount() {
    return this._hwpProblemCount
  }

  get additionalPricingPlanStandardValue() {
    return this._additionalPricingPlanStandardValue
  }

  get additionalPricingPlanFreeStudentCount() {
    return this._additionalPricingPlanFreeStudentCount
  }

  get additionalStudentCount() {
    return this._additionalStudentCount
  }

  get activeStudentCount() {
    return this._activeStudentCount
  }

  get invoiceStartDatetime() {
    return this._invoiceStartDatetime
  }

  get invoiceEndDatetime() {
    return this._invoiceEndDatetime
  }

  get paymentDate() {
    return this._paymentDate
  }

  get debt() {
    return this._debt
  }

  get paymentAmountExceptMessageFee() {
    return this._paymentAmount + this._debt
  }

  constructor(dataFromRes: res.AcademyPayment) {
    super()
    this._subscribePlan = dataFromRes.subscribePlan
    this._additionalPricingPlan = dataFromRes.additionalPricingPlan
    this._additionalPricingPlanStandardValue = dataFromRes.additionalPricingPlanStandardValue
    this._additionalPricingPlanFreeStudentCount = dataFromRes.additionalPricingPlanFreeStudentCount
    this._additionalPricingPlanFeeOnEachStudent = dataFromRes.additionalPricingPlanFeeOnEachStudent
    this._additionalStudentCount = dataFromRes.additionalStudentCount
    this._activeStudentCount = dataFromRes.activeStudentCount
    this._subscribeFee = dataFromRes.subscribeFee
    this._additionalFee = dataFromRes.additionalFee
    this._additionalHwpFee = dataFromRes.additionalHwpFee || 0
    this._hwpProblemCount = dataFromRes.hwpProblemCount || 0
    this._invoiceStartDatetime = dataFromRes.invoiceStartDatetime
      ? new Date(dataFromRes.invoiceStartDatetime)
      : new Date()
    this._invoiceEndDatetime = dataFromRes.invoiceEndDatetime
      ? new Date(dataFromRes.invoiceEndDatetime)
      : new Date()
    this._paymentDate = dataFromRes.paymentDate ? new Date(dataFromRes.paymentDate) : new Date()
    this._paymentAmount = dataFromRes.paymentAmount
    this._debt = dataFromRes.debt
  }
}
